
const transactionTypes = [
    {name: 'directPartner', class: 'matrix-node-direct'},
    {name: 'spillOverAbove', class: 'matrix-node-spillover-above'},
    {name: 'spillOverBelow', class: 'matrix-node-spillover-below'},
    {name: 'freeFlow', class: 'matrix-node-direct'}
]

// const transactionTypes = [
//     {name: 'directPartner', class: 'bg-white'},
//     {name: 'spillOverAbove', class: 'bg-light-blue'},
//     {name: 'spillOverBelow', class: 'bg-yellow'},
//     {name: 'freeFlow', class: 'bg-green-500'}
// ]

export default transactionTypes;